import React from "react";
import { Smartphone, Tv, Monitor, MessageCircle, Tv2, CheckCircle2, XCircle, Apple, Radio } from "lucide-react";
import { DOWNLOADS_WA_LINK } from "./constants";

const WORKS_ON = [
  { icon: Smartphone, text: "Celulares e tablets Android (5.0 ou superior)" },
  { icon: Tv, text: "Android TV (Mi Box, Nvidia Shield, Chromecast)" },
  { icon: Monitor, text: "TV Box (com sistema Android)" },
  { icon: Tv2, text: "Amazon Fire TV (com sideload)" },
];

const NOT_ON = [
  { icon: Apple, text: "iPhone e iPad (iOS) — use o Smarters Player Lite acima" },
  { icon: Tv2, text: "Smart TV LG (webOS) — usa app pela loja" },
  { icon: Tv2, text: "Smart TV Samsung (Tizen) — usa app pela loja" },
  { icon: Radio, text: "Roku — usa canal pela loja Roku" },
];

const DeviceList = ({ items, iconClass }) => (
  <ul className="space-y-2 text-sm text-white/85">
    {items.map(({ icon: Icon, text }) => (
      <li key={text} className="flex items-center gap-2"><Icon className={`w-4 h-4 ${iconClass}`} /> {text}</li>
    ))}
  </ul>
);

export const CompatibilitySection = () => (
  <section className="max-w-[1100px] mx-auto px-6 pb-12">
    <h3 className="text-2xl font-bold text-center mb-6">Compatibilidade do APK Android</h3>
    <div className="grid md:grid-cols-2 gap-4">
      <div className="rounded-2xl border border-emerald-500/30 bg-emerald-500/5 p-5">
        <div className="flex items-center gap-2 text-emerald-400 font-bold mb-3">
          <CheckCircle2 className="w-5 h-5" /> Funciona em
        </div>
        <DeviceList items={WORKS_ON} iconClass="text-emerald-400" />
      </div>

      <div className="rounded-2xl border border-red-500/30 bg-red-500/5 p-5">
        <div className="flex items-center gap-2 text-red-400 font-bold mb-3">
          <XCircle className="w-5 h-5" /> NÃO funciona em
        </div>
        <DeviceList items={NOT_ON} iconClass="text-red-400" />
        <a
          href={DOWNLOADS_WA_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 inline-flex items-center gap-2 text-sm text-[#25D366] hover:underline font-semibold"
        >
          <MessageCircle className="w-4 h-4" /> Tem outro aparelho? Fale com o suporte
        </a>
      </div>
    </div>
  </section>
);
